// extracted by mini-css-extract-plugin
export default {"post-comment-container":"style_post-comment-container__st35I","post-comment":"style_post-comment__8b0tS"};